import { Link, useParams } from 'react-router'

import { ArrowLeft } from '@phosphor-icons/react'
import { memo } from 'react'
import { Button } from '@/components/ui'
import { FinancialTablesLink } from '@/feature/financial-model/components/FinancialTablesLink'

export const EcommerceCommonHeader = memo((props: { linkText: string; path: string; hideFinancialTablesLink?: boolean }) => {
  const { id } = useParams<{ id: string }>()
  return (
    <div className='flex w-full items-center justify-between'>
      <Button size='md' asChild variant='link'>
        <Link to={props.path}>
          <ArrowLeft size={16} className='mr-2' weight='bold' />
          {props.linkText}
        </Link>
      </Button>
      {!props.hideFinancialTablesLink && <FinancialTablesLink financialModelId={id!} />}
    </div>
  )
})
